import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import {
  Container, Row, Col, Card, CardBody, Badge, Spinner,
  Button, Nav, NavItem, NavLink, TabContent, TabPane,
  Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import moment from "moment";
import classnames from "classnames";

const API_BASE = "https://seendinapi.stechomeyazilim.info/api";

const UserDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  document.title = `Kullanıcı Detay #${id} | SeendIN Admin Paneli`;

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("selfies");
  const [tabData, setTabData] = useState({ selfies: [], likes: [], matches: [], memberships: [], avatars: [] });
  const [tabLoading, setTabLoading] = useState(false);
  const [avatarModal, setAvatarModal] = useState(false);
  const [allAvatars, setAllAvatars] = useState([]);
  const [assigning, setAssigning] = useState(false);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/users/${id}`);
      setUser(res.data);
    } catch (error) {
      console.error("Kullanıcı detayı alınamadı", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTabData = async (tab) => {
    setTabLoading(true);
    try {
      let res;
      switch (tab) {
        case "selfies": res = await axios.get(`${API_BASE}/selfies/user/${id}`); break;
        case "likes": res = await axios.get(`${API_BASE}/likes/sent/${id}`); break;
        case "matches": res = await axios.get(`${API_BASE}/matches/user/${id}`); break;
        case "memberships": res = await axios.get(`${API_BASE}/memberships/all`); break;
        case "avatars": res = await axios.get(`${API_BASE}/avatars/user/${id}`); break;
        default: return;
      }
      const data = Array.isArray(res.data) ? res.data : (res.data.data || []);
      if (tab === "memberships") {
        setTabData(prev => ({ ...prev, [tab]: data.filter(m => m.UserID == id || m.userID == id) }));
      } else {
        setTabData(prev => ({ ...prev, [tab]: data }));
      }
    } catch (error) {
      console.error(`${tab} verileri alınamadı`, error);
    } finally {
      setTabLoading(false);
    }
  };

  useEffect(() => { fetchUser(); }, [id]);
  useEffect(() => { if (user) fetchTabData(activeTab); }, [activeTab, user]);

  const toggleAvatarModal = () => {
    if (!avatarModal) fetchAllAvatars();
    setAvatarModal(!avatarModal);
  };

  const fetchAllAvatars = async () => {
    try {
      const res = await axios.get(`${API_BASE}/avatars`);
      setAllAvatars(res.data || []);
    } catch (err) {
      console.error("Avatar fetch error:", err);
    }
  };

  const handleAssignAvatar = async (avatarId) => {
    setAssigning(true);
    try {
      await axios.post(`${API_BASE}/avatars/user`, {
        UserID: parseInt(id),
        AvatarID: avatarId,
        ObtainedVia: "admin"
      });
      toggleAvatarModal();
      fetchTabData("avatars");
    } catch (err) {
      alert(err.response?.data?.message || "Avatar atanırken hata oluştu.");
    }
    setAssigning(false);
  };

  const getGenderLabel = (gender) => {
    if (!gender) return "-";
    const g = String(gender).toLowerCase();
    if (g === "male" || g === "m" || g === "erkek") return "Erkek";
    if (g === "female" || g === "f" || g === "kadın" || g === "kadin") return "Kadın";
    return gender;
  };

  if (loading) return <div className="text-center py-5"><Spinner color="primary" /><p className="text-muted mt-2">Yükleniyor...</p></div>;
  if (!user) return <div className="text-center py-5 text-muted">Kullanıcı bulunamadı.</div>;

  const age = user.BirthDate ? moment().diff(moment(user.BirthDate), "years") : "-";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem={`Kullanıcı Detay #${id}`} />

          <Row className="mb-4">
            <Col lg="4">
              <Card>
                <CardBody className="text-center">
                  <div className="avatar-lg mx-auto mb-3">
                    <span className="avatar-title rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: 80, height: 80, fontSize: 32 }}>
                      {(user.PhoneNumber || "?").charAt(0)}
                    </span>
                  </div>
                  <h5 className="mb-1">Kullanıcı #{user.ID}</h5>
                  <p className="text-muted">{user.PhoneNumber || "-"}</p>
                  <div className="d-flex justify-content-center gap-2 mb-3">
                    {user.IsBanned ? <Badge color="danger">Yasaklı</Badge> : null}
                    {user.IsFrozen ? <Badge color="warning">Dondurulmuş</Badge> : null}
                    {user.IsActive !== false ? <Badge color="success">Aktif</Badge> : <Badge color="secondary">Pasif</Badge>}
                  </div>
                  <Button color="primary" size="sm" className="mb-3" onClick={toggleAvatarModal}>
                    <i className="bx bx-face me-1" /> Avatar Ata
                  </Button>
                  <Button color="secondary" size="sm" onClick={() => navigate("/users")}>← Kullanıcı Listesine Dön</Button>
                </CardBody>
              </Card>
            </Col>
            <Col lg="8">
              <Card>
                <CardBody>
                  <h5 className="card-title mb-4">Profil Bilgileri</h5>
                  <Row>
                    <Col md="6">
                      <p><strong>Cinsiyet:</strong> {getGenderLabel(user.Gender)}</p>
                      <p><strong>Yaş:</strong> {age}</p>
                      <p><strong>Doğum Tarihi:</strong> {user.BirthDate ? moment(user.BirthDate).format("DD.MM.YYYY") : "-"}</p>
                      <p><strong>Telefon Doğrulandı:</strong> {user.IsPhoneVerified ? "Evet" : "Hayır"}</p>
                      <p><strong>Yüz Doğrulandı:</strong> {user.IsFaceVerified ? "Evet" : "Hayır"}</p>
                    </Col>
                    <Col md="6">
                      <p><strong>Referans Kodu:</strong> {user.ReferralCode || "-"}</p>
                      <p><strong>Son Görülme:</strong> {user.LastSeenAt ? moment(user.LastSeenAt).format("DD.MM.YYYY HH:mm") : "-"}</p>
                      <p><strong>Kayıt Tarihi:</strong> {user.CreatedAt ? moment(user.CreatedAt).format("DD.MM.YYYY HH:mm") : "-"}</p>
                      <p><strong>Güncellenme:</strong> {user.UpdatedAt ? moment(user.UpdatedAt).format("DD.MM.YYYY HH:mm") : "-"}</p>
                      {user.IsBanned && <p><strong className="text-danger">Ban Sebebi:</strong> {user.BanReason || "-"}</p>}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem><NavLink className={classnames({ active: activeTab === "selfies" })} onClick={() => setActiveTab("selfies")}>Selfie'ler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "likes" })} onClick={() => setActiveTab("likes")}>Beğeniler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "matches" })} onClick={() => setActiveTab("matches")}>Eşleşmeler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "memberships" })} onClick={() => setActiveTab("memberships")}>Üyelikler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "avatars" })} onClick={() => setActiveTab("avatars")}>Avatarlar</NavLink></NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab} className="p-3">
                    <TabPane tabId="selfies">
                      {tabLoading ? <div className="text-center"><Spinner size="sm" /></div> :
                        tabData.selfies.length === 0 ? <p className="text-muted">Selfie bulunamadı.</p> :
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead><tr><th>#</th><th>Foto</th><th>Şehir</th><th>Görüntülenme</th><th>Durum</th><th>Tarih</th></tr></thead>
                            <tbody>
                              {tabData.selfies.map((s, i) => (
                                <tr key={s.ID || i}>
                                  <td>{i + 1}</td>
                                  <td>{s.ThumbnailUrl ? <img src={s.ThumbnailUrl} alt="" style={{ width: 40, height: 40, borderRadius: 4, objectFit: "cover" }} /> : "-"}</td>
                                  <td>{s.City || "-"}</td>
                                  <td>{s.ViewCount || 0}</td>
                                  <td><Badge color={s.IsActive ? "success" : "secondary"} className="font-size-11">{s.IsActive ? "Aktif" : "Pasif"}</Badge></td>
                                  <td>{s.CreatedAt ? moment(s.CreatedAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      }
                    </TabPane>
                    <TabPane tabId="likes">
                      {tabLoading ? <div className="text-center"><Spinner size="sm" /></div> :
                        tabData.likes.length === 0 ? <p className="text-muted">Beğeni bulunamadı.</p> :
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead><tr><th>#</th><th>Alıcı</th><th>Selfie</th><th>Tip</th><th>Tarih</th></tr></thead>
                            <tbody>
                              {tabData.likes.map((l, i) => (
                                <tr key={l.ID || i}>
                                  <td>{i + 1}</td>
                                  <td>{l.ReceiverID || "-"}</td>
                                  <td>{l.SelfieID || "-"}</td>
                                  <td><Badge color="info" className="font-size-11">{l.LikeType || "normal"}</Badge></td>
                                  <td>{l.CreatedAt ? moment(l.CreatedAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      }
                    </TabPane>
                    <TabPane tabId="matches">
                      {tabLoading ? <div className="text-center"><Spinner size="sm" /></div> :
                        tabData.matches.length === 0 ? <p className="text-muted">Eşleşme bulunamadı.</p> :
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead><tr><th>#</th><th>Kullanıcı 2</th><th>Durum</th><th>Bitiş</th><th>Tarih</th></tr></thead>
                            <tbody>
                              {tabData.matches.map((m, i) => (
                                <tr key={m.ID || i}>
                                  <td>{i + 1}</td>
                                  <td>{m.User2ID || m.User1ID || "-"}</td>
                                  <td><Badge color={m.Status === "active" ? "success" : "secondary"} className="font-size-11">{m.Status || "-"}</Badge></td>
                                  <td>{m.ExpiresAt ? moment(m.ExpiresAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                  <td>{m.CreatedAt ? moment(m.CreatedAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      }
                    </TabPane>
                    <TabPane tabId="memberships">
                      {tabLoading ? <div className="text-center"><Spinner size="sm" /></div> :
                        tabData.memberships.length === 0 ? <p className="text-muted">Üyelik bulunamadı.</p> :
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead><tr><th>#</th><th>Tip ID</th><th>Başlangıç</th><th>Bitiş</th><th>Durum</th></tr></thead>
                            <tbody>
                              {tabData.memberships.map((m, i) => (
                                <tr key={m.ID || i}>
                                  <td>{i + 1}</td>
                                  <td>{m.MembershipTypeID || "-"}</td>
                                  <td>{m.StartsAt ? moment(m.StartsAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                  <td>{m.EndsAt ? moment(m.EndsAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                  <td><Badge color={m.IsActive ? "success" : "secondary"} className="font-size-11">{m.IsActive ? "Aktif" : "Pasif"}</Badge></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      }
                    </TabPane>
                    <TabPane tabId="avatars">
                      {tabLoading ? <div className="text-center"><Spinner size="sm" /></div> :
                        tabData.avatars.length === 0 ? <p className="text-muted">Avatar bulunamadı.</p> :
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead><tr><th>#</th><th>Avatar</th><th>Ad</th><th>Kategori</th><th>Edinme</th><th>Tarih</th></tr></thead>
                            <tbody>
                              {tabData.avatars.map((a, i) => (
                                <tr key={a.ID || i}>
                                  <td>{i + 1}</td>
                                  <td>{a.Avatar?.ImageUrl ? <img src={a.Avatar.ImageUrl} alt="" style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }} /> : "-"}</td>
                                  <td>{a.Avatar?.Name || "-"}</td>
                                  <td><Badge color="info" className="font-size-11">{a.Avatar?.Category || "-"}</Badge></td>
                                  <td>{a.ObtainedVia || "-"}</td>
                                  <td>{a.ObtainedAt ? moment(a.ObtainedAt).format("DD.MM.YYYY HH:mm") : "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      }
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Avatar Ata Modal */}
      <Modal isOpen={avatarModal} toggle={toggleAvatarModal} size="lg">
        <ModalHeader toggle={toggleAvatarModal}>Kullanıcıya Avatar Ata #{id}</ModalHeader>
        <ModalBody>
          {allAvatars.length === 0 ? (
            <p className="text-muted text-center">Henüz avatar bulunmuyor. Önce Avatar Yönetimi sayfasından yükleyin.</p>
          ) : (
            <Row>
              {allAvatars.map((a) => (
                <Col md={3} sm={6} key={a.ID} className="mb-3">
                  <Card className="h-100 text-center" onClick={() => handleAssignAvatar(a.ID)} style={{ cursor: "pointer" }}>
                    <CardBody>
                      <img
                        src={a.ImageUrl}
                        alt={a.Name}
                        style={{ width: 64, height: 64, objectFit: "cover", borderRadius: "50%", marginBottom: 8 }}
                        onError={(e) => { e.target.src = "https://via.placeholder.com/64"; }}
                      />
                      <h6 className="mb-1 font-size-12">{a.Name}</h6>
                      <Badge color="info" className="font-size-10">{a.Category}</Badge>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAvatarModal} disabled={assigning}>Kapat</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(UserDetail);
